export const lighteningData = [


    {
        id: 1,
        name: 'light sputnik linear chandelier ',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/67823905/resize-h416-w416%5Ecompr-r85/3705/37057518/Fairfax+8+-+Light+Sputnik+Modern+Linear+Chandelier.jpg'
    },
    {
        id: 2,
        name: 'light unique globe chandelier',
        price: '$380',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/22036425/resize-h416-w416%5Ecompr-r85/9625/96258385/Sappho+Orb+9-Light+Unique+/+Statement+Globe+Chandelier.jpg'
    },
    {
        id: 3,
        name: 'Dante Drum chandelier ',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/03266954/resize-h416-w416%5Ecompr-r85/7693/76932772/Dante+5+-+Light+Unique+/+Statement+Drum+Chandelier.jpg'
    },
    {
        id: 4,
        name: 'currey & company globe chandelier',
        price: '$299.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/41904448/resize-h416-w416%5Ecompr-r85/1029/102926155/6+-+Light+Unique+/+Statement+Globe+Chandelier.jpg'
    },
    {
        id: 5,
        name: 'Light single teardrop pendant',
        price: '$250',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/22144617/resize-h416-w416%5Ecompr-r85/2794/27949045/Sky-Fall+2+-+Light+Single+Teardrop+Pendant.jpg'
    },
    {
        id: 6,
        name: 'light single drum pendant',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/94208213/resize-h416-w416%5Ecompr-r85/5403/54035579/1+-+Light+Single+Drum+Pendant.jpg'
    },
    {
        id: 7,
        name: 'wearstler strada sconce',
        price: '$619.99',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/09515011/resize-h416-w416%5Ecompr-r85/9383/93836663/Kelly+Wearstler+Strada+Small+Sconce.jpg'
    },
    {
        id: 8,
        name: 'studio italia design- light flush mount',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/94352336/resize-h416-w416%5Ecompr-r85/5249/52497741/Make-Up+1-Light+Flush+Mount.jpg'
    },
    {
        id: 9,
        name: 'edmund light antique brass wallchiere',
        price: '$160',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/15428976/resize-h416-w416%5Ecompr-r85/9861/98611930/Edmund+1+-+Light+Antique+Brass+Wallchiere.jpg'
    },
    {
        id: 10,
        name: 'vida 2-light flush mount',
        price: '$200',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/59746084/resize-h416-w416%5Ecompr-r85/4964/49641889/Vida+2-Light+Flush+Mount.jpg'
    },
    {
        id: 11,
        name: 'alexa hampton basil flush mount',
        price: '$600',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/58837951/resize-h416-w416%5Ecompr-r85/9383/93836362/Alexa+Hampton+Basil+Large+Flush+Mount.jpg'
    },
    {
        id: 12,
        name: 'Hampton light semi flush mount',
        price: '$400',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/71150124/resize-h416-w416%5Ecompr-r85/1498/14984261/Hampton+3-Light+Semi+Flush+Mount.jpg'
    },
    {
        id: 13,
        name: 'keaton light directional spotlight',
        price: '$190',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/92981369/resize-h416-w416%5Ecompr-r85/4561/45612392/Keaton+6+Light+Directional+%2526+Spotlight.jpg'
    },
    {
        id: 14,
        name: 'aidan gray hammered flush mount',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/48990442/resize-h416-w416%5Ecompr-r85/4577/45771654/Hammered+Flush+Mount.jpg'
    },
    {
        id: 15,
        name: 'fine art lamps flush mount',
        price: '$350',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/3048473/resize-h416-w416%5Ecompr-r85/1197/119770920/Beekman+Place+4-Light+18%2522+Flush+Mount.jpg'
    },
    {
        id: 16,
        name: 'kestrel geometric flush light',
        price: '$300',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/78444360/resize-h416-w416%5Ecompr-r85/4964/49641874/Kestrel+3+-+Light+16%2522+Unique/Statement+Geometric+Semi+Flush+Mount.jpg'
    },
    {
        id: 17,
        name: 'kravet owen 34" table lamp',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/40502713/resize-h416-w416%5Ecompr-r85/1081/108190285/Owen+34%2522+Table+Lamp.jpg'
    },
    {
        id: 18,
        name: 'emerald  green standard table lamp',
        price: '$299',
        imageUrl: 'https://secure.img1-fg.wfcdn.com/im/65298172/resize-h416-w416%5Ecompr-r85/1112/111275060/31%2522+Emerald+Green+Standard+Table+Lamp.jpg'
    }

]